import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Routes } from "router/config";
import { getCurrentLanguage, useTranslation, t as tStatic } from "locales";
import { getFeaturesContent } from "./content";
import "./style.scss";

function setMeta(name: string, value: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setOg(prop: string, value: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(url: string) {
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

/* ═══════════════════════════════════════════
   SVG Infographic Illustrations
   ═══════════════════════════════════════════ */

function InfographicMessaging() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Thread list */}
      <rect x="0" y="0" width="160" height="340" rx="16" fill="var(--palette-main-bg)" />
      <rect x="160" y="0" width="1" height="340" fill="var(--palette-neutral-lighten-2)" />

      {/* Search bar */}
      <rect x="12" y="12" width="136" height="28" rx="14" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <circle cx="28" cy="26" r="6" stroke="var(--palette-neutral)" strokeWidth="1.5" fill="none" />
      <line x1="32" y1="30" x2="36" y2="34" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeLinecap="round" />
      <text x="44" y="30" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Search chats...")}</text>

      {/* Thread item 1 - active with pin */}
      <rect x="8" y="48" width="144" height="52" rx="8" fill="var(--palette-primary)" opacity="0.1" />
      <circle cx="28" cy="74" r="14" fill="var(--palette-primary)" opacity="0.25" />
      <text x="28" y="78" textAnchor="middle" fill="var(--palette-primary)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">DP</text>
      <rect x="48" y="62" width="60" height="8" rx="4" fill="var(--palette-foreground)" opacity="0.8" />
      <rect x="48" y="76" width="80" height="6" rx="3" fill="var(--palette-neutral)" opacity="0.5" />
      {/* Pin icon */}
      <circle cx="136" cy="62" r="6" fill="var(--palette-primary)" opacity="0.15" />
      <text x="136" y="65" textAnchor="middle" fontSize="7" fill="var(--palette-primary)">&#128204;</text>

      {/* Thread item 2 - unread */}
      <rect x="8" y="106" width="144" height="52" rx="8" fill="transparent" />
      <circle cx="28" cy="132" r="14" fill="var(--palette-neutral)" opacity="0.12" />
      <text x="28" y="136" textAnchor="middle" fill="var(--palette-neutral)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">TS</text>
      <rect x="48" y="120" width="50" height="8" rx="4" fill="var(--palette-foreground)" opacity="0.5" />
      <rect x="48" y="134" width="72" height="6" rx="3" fill="var(--palette-neutral)" opacity="0.4" />
      {/* Unread badge */}
      <circle cx="136" cy="132" r="9" fill="var(--palette-primary)" />
      <text x="136" y="136" textAnchor="middle" fill="white" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">5</text>

      {/* Thread item 3 - group with mention badge */}
      <rect x="8" y="164" width="144" height="52" rx="8" fill="transparent" />
      <rect x="14" y="176" width="28" height="28" rx="8" fill="var(--palette-positive)" opacity="0.15" />
      <text x="28" y="194" textAnchor="middle" fill="var(--palette-positive)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">D</text>
      <rect x="48" y="178" width="56" height="8" rx="4" fill="var(--palette-foreground)" opacity="0.5" />
      <rect x="48" y="192" width="68" height="6" rx="3" fill="var(--palette-neutral)" opacity="0.4" />
      {/* @ mention badge */}
      <rect x="122" y="184" width="26" height="16" rx="8" fill="var(--palette-primary)" />
      <text x="135" y="195" textAnchor="middle" fill="white" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">@2</text>

      {/* Chat area messages */}
      {/* Incoming */}
      <rect x="176" y="16" width="190" height="40" rx="12" fill="var(--palette-input-bg)" />
      <text x="188" y="32" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">David Park</text>
      <text x="188" y="46" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("The quarterly review is scheduled")}</text>

      {/* Reaction bar */}
      <rect x="176" y="60" width="40" height="18" rx="9" fill="var(--palette-primary)" opacity="0.1" />
      <text x="184" y="73" fontSize="9">&#128077; 3</text>
      <rect x="220" y="60" width="40" height="18" rx="9" fill="rgba(var(--palette-negative-rgb), 0.1)" />
      <text x="228" y="73" fontSize="9">&#10084; 1</text>

      {/* Outgoing with read receipt */}
      <rect x="270" y="88" width="234" height="36" rx="12" fill="var(--palette-primary)" />
      <text x="282" y="110" fill="white" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Perfect, I'll prepare the slides")}</text>
      <text x="494" y="118" fill="var(--palette-primary)" fontSize="9">&#10003;&#10003;</text>

      {/* Edited message */}
      <rect x="176" y="136" width="220" height="48" rx="12" fill="var(--palette-input-bg)" />
      <text x="188" y="152" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">David Park</text>
      <text x="188" y="168" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Updated: meeting moved to 3 PM")}</text>
      <rect x="188" y="172" width="36" height="12" rx="6" fill="var(--palette-neutral)" opacity="0.15" />
      <text x="193" y="181" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("edited")}</text>

      {/* Mention message */}
      <rect x="176" y="196" width="240" height="36" rx="12" fill="var(--palette-input-bg)" />
      <text x="188" y="218" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">
        <tspan fill="var(--palette-primary)" fontWeight="700">{t("@You")}</tspan> {t("can you share the deck?")}
      </text>
      {/* Highlight glow */}
      <rect x="174" y="194" width="244" height="40" rx="13" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" fill="none" />

      {/* Date separator */}
      <line x1="176" y1="248" x2="280" y2="248" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="324" y="252" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Today")}</text>
      <line x1="368" y1="248" x2="504" y2="248" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />

      {/* File attachment message */}
      <rect x="290" y="264" width="214" height="48" rx="12" fill="var(--palette-primary)" />
      <text x="302" y="282" fill="white" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Here's the latest version")}</text>
      <rect x="302" y="290" width="130" height="18" rx="6" fill="rgba(255,255,255,0.2)" />
      <text x="312" y="303" fill="white" fontSize="8" fontFamily="Open Sans, sans-serif">presentation-v3.pdf</text>
      <text x="440" y="303" fill="rgba(255,255,255,0.5)" fontSize="7">2.4 MB</text>

      {/* Input bar */}
      <rect x="172" y="322" width="340" height="1" fill="var(--palette-neutral-lighten-2)" />

      {/* Annotation labels */}
      <rect x="8" y="232" width="144" height="44" rx="8" fill="transparent" />
      <rect x="12" y="236" width="68" height="16" rx="8" fill="var(--palette-primary)" opacity="0.08" />
      <text x="18" y="248" fill="var(--palette-primary)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("PIN + HIDE")}</text>
      <rect x="84" y="236" width="64" height="16" rx="8" fill="var(--palette-positive)" opacity="0.08" />
      <text x="90" y="248" fill="var(--palette-positive)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("SEARCH")}</text>
      <rect x="12" y="256" width="80" height="16" rx="8" fill="var(--palette-warning)" opacity="0.08" />
      <text x="18" y="268" fill="var(--palette-warning)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("@MENTIONS")}</text>
      <rect x="96" y="256" width="52" height="16" rx="8" fill="var(--palette-negative)" opacity="0.08" />
      <text x="102" y="268" fill="var(--palette-negative)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("EMOJI")}</text>
    </svg>
  );
}

function InfographicVideo() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="#15191f" />

      {/* Main speaker */}
      <rect x="12" y="12" width="340" height="260" rx="12" fill="#1e242c" />
      <circle cx="182" cy="120" r="50" fill="var(--palette-primary)" opacity="0.15" />
      <text x="182" y="130" textAnchor="middle" fill="var(--palette-primary)" fontSize="32" fontWeight="700" fontFamily="Open Sans, sans-serif">SK</text>
      <text x="182" y="200" textAnchor="middle" fill="rgba(255,255,255,0.8)" fontSize="14" fontWeight="600" fontFamily="Open Sans, sans-serif">Sarah Kim</text>
      <text x="182" y="218" textAnchor="middle" fill="rgba(255,255,255,0.35)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Speaking...")}</text>
      {/* Active speaker glow */}
      <rect x="12" y="12" width="340" height="260" rx="12" stroke="var(--palette-primary)" strokeWidth="2" fill="none" opacity="0.6" />

      {/* REC indicator */}
      <rect x="24" y="24" width="52" height="22" rx="11" fill="var(--palette-negative)" />
      <circle cx="38" cy="35" r="4" fill="white" />
      <text x="48" y="39" fill="white" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">REC</text>

      {/* Screen share badge */}
      <rect x="250" y="24" width="90" height="22" rx="11" fill="rgba(255,255,255,0.12)" />
      <text x="264" y="39" fill="rgba(255,255,255,0.7)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Screen Share")}</text>

      {/* Sidebar thumbnails */}
      <rect x="362" y="12" width="146" height="78" rx="8" fill="#1e242c" />
      <circle cx="435" cy="42" r="18" fill="var(--palette-positive)" opacity="0.2" />
      <text x="435" y="47" textAnchor="middle" fill="var(--palette-positive)" fontSize="14" fontWeight="700" fontFamily="Open Sans, sans-serif">DP</text>
      <text x="435" y="72" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="8" fontFamily="Open Sans, sans-serif">David Park</text>
      {/* Mic indicator */}
      <circle cx="380" cy="72" r="6" fill="var(--palette-positive)" opacity="0.3" />
      <rect x="378" y="66" width="4" height="8" rx="2" fill="var(--palette-positive)" />

      <rect x="362" y="96" width="146" height="78" rx="8" fill="#1e242c" />
      <circle cx="435" cy="126" r="18" fill="var(--palette-warning)" opacity="0.2" />
      <text x="435" y="131" textAnchor="middle" fill="var(--palette-warning)" fontSize="14" fontWeight="700" fontFamily="Open Sans, sans-serif">MR</text>
      <text x="435" y="156" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="8" fontFamily="Open Sans, sans-serif">Mike Ross</text>
      {/* Muted mic */}
      <circle cx="380" cy="156" r="6" fill="var(--palette-negative)" opacity="0.3" />
      <line x1="377" y1="153" x2="383" y2="159" stroke="var(--palette-negative)" strokeWidth="1.5" strokeLinecap="round" />

      <rect x="362" y="180" width="146" height="78" rx="8" fill="#1e242c" />
      <circle cx="435" cy="210" r="18" fill="var(--palette-negative)" opacity="0.2" />
      <text x="435" y="215" textAnchor="middle" fill="var(--palette-negative)" fontSize="14" fontWeight="700" fontFamily="Open Sans, sans-serif">AJ</text>
      <text x="435" y="240" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="8" fontFamily="Open Sans, sans-serif">Anna Jones</text>

      {/* Participant count */}
      <rect x="362" y="266" width="146" height="6" rx="3" fill="rgba(255,255,255,0.05)" />
      <text x="435" y="262" textAnchor="middle" fill="rgba(255,255,255,0.35)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("4 participants")}</text>

      {/* Controls bar */}
      <rect x="100" y="290" width="320" height="38" rx="19" fill="rgba(255,255,255,0.08)" />

      {/* Mic btn */}
      <circle cx="170" cy="309" r="14" fill="rgba(255,255,255,0.1)" />
      <rect x="167" y="300" width="6" height="12" rx="3" fill="var(--palette-positive)" />
      <text x="170" y="330" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Mic")}</text>

      {/* Camera btn */}
      <circle cx="220" cy="309" r="14" fill="rgba(255,255,255,0.1)" />
      <rect x="211" y="303" width="12" height="9" rx="2" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" fill="none" />
      <path d="M223 305L229 302V316L223 313" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" />
      <text x="220" y="330" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Camera")}</text>

      {/* Screen share btn */}
      <circle cx="270" cy="309" r="14" fill="var(--palette-primary)" opacity="0.2" />
      <rect x="261" y="302" width="14" height="10" rx="2" stroke="var(--palette-primary)" strokeWidth="1.5" fill="none" />
      <line x1="268" y1="312" x2="268" y2="316" stroke="var(--palette-primary)" strokeWidth="1.5" />
      <line x1="263" y1="316" x2="273" y2="316" stroke="var(--palette-primary)" strokeWidth="1.5" strokeLinecap="round" />
      <text x="270" y="330" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Share")}</text>

      {/* Record btn */}
      <circle cx="320" cy="309" r="14" fill="var(--palette-negative)" opacity="0.2" />
      <circle cx="320" cy="309" r="6" fill="var(--palette-negative)" />
      <text x="320" y="330" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Record")}</text>

      {/* End call */}
      <circle cx="370" cy="309" r="14" fill="var(--palette-negative)" />
      <rect x="362" y="306" width="16" height="6" rx="3" fill="white" />
      <text x="370" y="330" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("End")}</text>
    </svg>
  );
}

function InfographicGroups() {
  const { t } = useTranslation();
  const groupCards = [
    { y: 88, name: t("Design Team"), members: t("{{count}} members", { count: 12 }), color: "var(--palette-primary)", initial: "D", joined: true },
    { y: 148, name: t("Engineering"), members: t("{{count}} members", { count: 34 }), color: "var(--palette-positive)", initial: "E", joined: false },
    { y: 208, name: t("Marketing"), members: t("{{count}} members", { count: 8 }), color: "var(--palette-warning)", initial: "M", joined: false },
    { y: 268, name: t("All Hands"), members: t("{{count}} members", { count: 56 }), color: "var(--palette-negative)", initial: "A", joined: true },
  ];
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Left: Group creation form */}
      <rect x="16" y="16" width="230" height="308" rx="12" fill="var(--palette-main-bg)" />
      <text x="32" y="42" fill="var(--palette-foreground)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Create Group")}</text>

      {/* Group name input */}
      <text x="32" y="64" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("GROUP NAME")}</text>
      <rect x="28" y="70" width="200" height="28" rx="6" fill="var(--palette-white)" stroke="var(--palette-primary)" strokeWidth="1.5" />
      <text x="38" y="88" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Design Team")}</text>

      {/* Members chips */}
      <text x="32" y="116" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("MEMBERS")}</text>
      <rect x="28" y="122" width="200" height="56" rx="6" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <rect x="34" y="128" width="64" height="20" rx="10" fill="var(--palette-primary)" opacity="0.1" />
      <text x="42" y="142" fill="var(--palette-primary)" fontSize="8" fontWeight="600" fontFamily="Open Sans, sans-serif">Sarah K. x</text>
      <rect x="102" y="128" width="58" height="20" rx="10" fill="var(--palette-primary)" opacity="0.1" />
      <text x="108" y="142" fill="var(--palette-primary)" fontSize="8" fontWeight="600" fontFamily="Open Sans, sans-serif">Mike R. x</text>
      <rect x="164" y="128" width="56" height="20" rx="10" fill="var(--palette-primary)" opacity="0.1" />
      <text x="170" y="142" fill="var(--palette-primary)" fontSize="8" fontWeight="600" fontFamily="Open Sans, sans-serif">Anna J. x</text>
      <rect x="34" y="152" width="100" height="20" rx="6" fill="transparent" />
      <text x="38" y="164" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Search users...")}</text>

      {/* Toggles */}
      <rect x="28" y="190" width="200" height="1" fill="var(--palette-neutral-lighten-2)" />

      {/* Public toggle */}
      <text x="32" y="214" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Public group")}</text>
      <rect x="188" y="202" width="36" height="20" rx="10" fill="var(--palette-positive)" />
      <circle cx="214" cy="212" r="8" fill="white" />

      {/* Video calls toggle */}
      <text x="32" y="244" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Enable video calls")}</text>
      <rect x="188" y="232" width="36" height="20" rx="10" fill="var(--palette-positive)" />
      <circle cx="214" cy="242" r="8" fill="white" />

      {/* Create button */}
      <rect x="28" y="268" width="200" height="36" rx="10" fill="var(--palette-primary)" />
      <text x="128" y="290" textAnchor="middle" fill="white" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Create Group")}</text>

      {/* Right: Group catalog */}
      <rect x="262" y="16" width="242" height="308" rx="12" fill="var(--palette-main-bg)" />
      <text x="278" y="42" fill="var(--palette-foreground)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Public Groups")}</text>

      {/* Search bar */}
      <rect x="274" y="52" width="218" height="26" rx="13" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="290" y="69" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Search groups...")}</text>

      {/* Group cards */}
      {groupCards.map((g) => (
        <g key={g.name}>
          <rect x="274" y={g.y} width="218" height="52" rx="10" fill="var(--palette-white)" />
          <rect x="282" y={g.y + 8} width="36" height="36" rx="10" fill={g.color} opacity="0.12" />
          <text x="300" y={g.y + 32} textAnchor="middle" fill={g.color} fontSize="14" fontWeight="700" fontFamily="Open Sans, sans-serif">{g.initial}</text>
          <text x="326" y={g.y + 24} fill="var(--palette-foreground)" fontSize="11" fontWeight="600" fontFamily="Open Sans, sans-serif">{g.name}</text>
          <text x="326" y={g.y + 38} fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{g.members}</text>
          {g.joined ? (
            <>
              <rect x="440" y={g.y + 14} width="44" height="24" rx="12" fill="var(--palette-positive)" opacity="0.1" />
              <text x="462" y={g.y + 30} textAnchor="middle" fill="var(--palette-positive)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Joined")}</text>
            </>
          ) : (
            <>
              <rect x="440" y={g.y + 14} width="44" height="24" rx="12" fill="var(--palette-primary)" />
              <text x="462" y={g.y + 30} textAnchor="middle" fill="white" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Join")}</text>
            </>
          )}
        </g>
      ))}
    </svg>
  );
}

function InfographicFiles() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Title */}
      <text x="260" y="30" textAnchor="middle" fill="var(--palette-foreground)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Supported File Types")}</text>

      {/* 4 file type cards */}
      {/* Images */}
      <rect x="20" y="48" width="112" height="130" rx="12" fill="var(--palette-primary)" opacity="0.06" />
      <rect x="50" y="60" width="52" height="52" rx="14" fill="var(--palette-primary)" opacity="0.12" />
      <rect x="62" y="72" width="28" height="20" rx="4" stroke="var(--palette-primary)" strokeWidth="2" fill="none" />
      <circle cx="70" cy="82" r="3" fill="var(--palette-primary)" />
      <path d="M62 88L70 80L78 88" stroke="var(--palette-primary)" strokeWidth="1.5" fill="none" />
      <text x="76" y="128" textAnchor="middle" fill="var(--palette-primary)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Images")}</text>
      <text x="76" y="142" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("{{count}} formats", { count: 15 })}</text>
      <text x="76" y="154" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">JPG PNG WebP HEIF</text>
      <text x="76" y="166" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("+ inline preview")}</text>

      {/* Videos */}
      <rect x="144" y="48" width="112" height="130" rx="12" fill="var(--palette-positive)" opacity="0.06" />
      <rect x="174" y="60" width="52" height="52" rx="14" fill="var(--palette-positive)" opacity="0.12" />
      <rect x="186" y="72" width="28" height="20" rx="4" stroke="var(--palette-positive)" strokeWidth="2" fill="none" />
      <path d="M196 78L206 82L196 86Z" fill="var(--palette-positive)" />
      <text x="200" y="128" textAnchor="middle" fill="var(--palette-positive)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Videos")}</text>
      <text x="200" y="142" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("{{count}} formats", { count: 10 })}</text>
      <text x="200" y="154" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">MP4 WebM MKV AVI</text>
      <text x="200" y="166" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("+ range seeking")}</text>

      {/* Audio */}
      <rect x="268" y="48" width="112" height="130" rx="12" fill="var(--palette-warning)" opacity="0.06" />
      <rect x="298" y="60" width="52" height="52" rx="14" fill="var(--palette-warning)" opacity="0.12" />
      {/* Waveform icon */}
      <rect x="310" y="80" width="3" height="14" rx="1.5" fill="var(--palette-warning)" />
      <rect x="316" y="76" width="3" height="22" rx="1.5" fill="var(--palette-warning)" />
      <rect x="322" y="82" width="3" height="10" rx="1.5" fill="var(--palette-warning)" />
      <rect x="328" y="74" width="3" height="26" rx="1.5" fill="var(--palette-warning)" />
      <rect x="334" y="80" width="3" height="14" rx="1.5" fill="var(--palette-warning)" />
      <text x="324" y="128" textAnchor="middle" fill="var(--palette-warning)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Audio")}</text>
      <text x="324" y="142" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("{{count}} formats", { count: 4 })}</text>
      <text x="324" y="154" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">MP3 AAC OGG M4A</text>

      {/* Documents */}
      <rect x="392" y="48" width="112" height="130" rx="12" fill="var(--palette-negative)" opacity="0.06" />
      <rect x="422" y="60" width="52" height="52" rx="14" fill="var(--palette-negative)" opacity="0.12" />
      <rect x="436" y="70" width="24" height="30" rx="3" stroke="var(--palette-negative)" strokeWidth="2" fill="none" />
      <path d="M452 70L460 78" stroke="var(--palette-negative)" strokeWidth="2" fill="none" />
      <line x1="441" y1="82" x2="453" y2="82" stroke="var(--palette-negative)" strokeWidth="1.2" />
      <line x1="441" y1="88" x2="450" y2="88" stroke="var(--palette-negative)" strokeWidth="1.2" />
      <line x1="441" y1="94" x2="453" y2="94" stroke="var(--palette-negative)" strokeWidth="1.2" />
      <text x="448" y="128" textAnchor="middle" fill="var(--palette-negative)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Docs")}</text>
      <text x="448" y="142" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("{{count}} formats", { count: 3 })}</text>
      <text x="448" y="154" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">PDF DOC DOCX</text>

      {/* Upload flow */}
      <rect x="20" y="196" width="480" height="56" rx="12" fill="var(--palette-main-bg)" />
      <text x="40" y="218" fill="var(--palette-foreground)" fontSize="10" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Drag & Drop")}</text>
      <text x="40" y="234" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Drop files anywhere in the chat")}</text>
      {/* Arrow */}
      <path d="M148 220L168 220" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeLinecap="round" markerEnd="url(#arrowF)" />
      <text x="180" y="218" fill="var(--palette-foreground)" fontSize="10" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Upload")}</text>
      <text x="180" y="234" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Secure cloud, up to 2 GB")}</text>
      <path d="M280 220L300 220" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeLinecap="round" />
      <text x="312" y="218" fill="var(--palette-foreground)" fontSize="10" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Preview")}</text>
      <text x="312" y="234" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Inline thumbnails + lightbox")}</text>
      <path d="M418 220L438 220" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeLinecap="round" />
      <text x="448" y="218" fill="var(--palette-foreground)" fontSize="10" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Share")}</text>
      <text x="448" y="234" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Download link")}</text>

      {/* Upload progress demo */}
      <rect x="20" y="268" width="480" height="56" rx="12" fill="var(--palette-main-bg)" />
      <rect x="36" y="280" width="28" height="28" rx="6" fill="var(--palette-primary)" opacity="0.1" />
      <text x="50" y="298" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">PDF</text>
      <text x="78" y="294" fill="var(--palette-foreground)" fontSize="10" fontWeight="600" fontFamily="Open Sans, sans-serif">quarterly-report-2026.pdf</text>
      <text x="78" y="308" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">4.2 MB</text>
      {/* Progress bar */}
      <rect x="280" y="290" width="160" height="8" rx="4" fill="var(--palette-neutral)" opacity="0.12" />
      <rect x="280" y="290" width="112" height="8" rx="4" fill="var(--palette-primary)" />
      <text x="454" y="298" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">70%</text>
    </svg>
  );
}

function InfographicSecurity() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Center shield */}
      <path d="M260 30L200 60V120C200 170 225 200 260 215C295 200 320 170 320 120V60L260 30Z" fill="var(--palette-primary)" opacity="0.06" stroke="var(--palette-primary)" strokeWidth="2" />
      <path d="M240 110L252 122L280 94" stroke="var(--palette-primary)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />

      {/* Auth methods ring */}
      {/* Token */}
      <rect x="16" y="20" width="120" height="60" rx="12" fill="var(--palette-main-bg)" />
      <rect x="28" y="32" width="32" height="32" rx="8" fill="var(--palette-primary)" opacity="0.1" />
      <text x="44" y="52" textAnchor="middle" fill="var(--palette-primary)" fontSize="10" fontWeight="800" fontFamily="Open Sans, sans-serif">🔑</text>
      <text x="70" y="48" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Token Login")}</text>
      <text x="70" y="60" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Stays signed in")}</text>
      <line x1="136" y1="50" x2="200" y2="70" stroke="var(--palette-primary)" strokeWidth="1" strokeDasharray="4 3" opacity="0.3" />

      {/* QR */}
      <rect x="384" y="20" width="120" height="60" rx="12" fill="var(--palette-main-bg)" />
      <rect x="396" y="32" width="32" height="32" rx="8" fill="var(--palette-positive)" opacity="0.1" />
      <rect x="402" y="38" width="8" height="8" rx="1" fill="var(--palette-positive)" />
      <rect x="414" y="38" width="8" height="8" rx="1" fill="var(--palette-positive)" />
      <rect x="402" y="50" width="8" height="8" rx="1" fill="var(--palette-positive)" />
      <text x="438" y="48" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("QR Login")}</text>
      <text x="438" y="60" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("5-min TTL session")}</text>
      <line x1="384" y1="50" x2="320" y2="70" stroke="var(--palette-positive)" strokeWidth="1" strokeDasharray="4 3" opacity="0.3" />

      {/* Social */}
      <rect x="16" y="100" width="120" height="60" rx="12" fill="var(--palette-main-bg)" />
      <rect x="28" y="112" width="32" height="32" rx="8" fill="var(--palette-warning)" opacity="0.1" />
      <text x="44" y="132" textAnchor="middle" fill="var(--palette-warning)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">G</text>
      <text x="70" y="128" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Social Login")}</text>
      <text x="70" y="140" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">Google FB Twitter</text>
      <line x1="136" y1="130" x2="200" y2="110" stroke="var(--palette-warning)" strokeWidth="1" strokeDasharray="4 3" opacity="0.3" />

      {/* Roles */}
      <rect x="384" y="100" width="120" height="60" rx="12" fill="var(--palette-main-bg)" />
      <rect x="396" y="112" width="32" height="32" rx="8" fill="var(--palette-negative)" opacity="0.1" />
      <text x="412" y="132" textAnchor="middle" fill="var(--palette-negative)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">R</text>
      <text x="438" y="128" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Roles")}</text>
      <text x="438" y="140" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Owner · Admin · Member")}</text>
      <line x1="384" y1="130" x2="320" y2="110" stroke="var(--palette-negative)" strokeWidth="1" strokeDasharray="4 3" opacity="0.3" />

      {/* Bottom: QR flow diagram */}
      <rect x="20" y="232" width="480" height="92" rx="12" fill="var(--palette-main-bg)" />
      <text x="260" y="252" textAnchor="middle" fill="var(--palette-foreground)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("QR Authentication Flow")}</text>

      {/* Step 1 */}
      <circle cx="60" cy="290" r="18" fill="var(--palette-primary)" opacity="0.1" />
      <text x="60" y="294" textAnchor="middle" fill="var(--palette-primary)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">1</text>
      <text x="60" y="316" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Generate QR")}</text>

      <path d="M80 290L120 290" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1.5" />
      <polygon points="118,286 124,290 118,294" fill="var(--palette-neutral-lighten-2)" />

      {/* Step 2 */}
      <circle cx="150" cy="290" r="18" fill="var(--palette-primary)" opacity="0.1" />
      <text x="150" y="294" textAnchor="middle" fill="var(--palette-primary)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">2</text>
      <text x="150" y="316" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Scan on phone")}</text>

      <path d="M170 290L210 290" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1.5" />
      <polygon points="208,286 214,290 208,294" fill="var(--palette-neutral-lighten-2)" />

      {/* Step 3 */}
      <circle cx="240" cy="290" r="18" fill="var(--palette-primary)" opacity="0.1" />
      <text x="240" y="294" textAnchor="middle" fill="var(--palette-primary)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">3</text>
      <text x="240" y="316" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Confirm")}</text>

      <path d="M260 290L300 290" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1.5" />
      <polygon points="298,286 304,290 298,294" fill="var(--palette-neutral-lighten-2)" />

      {/* Step 4 */}
      <circle cx="330" cy="290" r="18" fill="var(--palette-primary)" opacity="0.1" />
      <text x="330" y="294" textAnchor="middle" fill="var(--palette-primary)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">4</text>
      <text x="330" y="316" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Poll status")}</text>

      <path d="M350 290L390 290" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1.5" />
      <polygon points="388,286 394,290 388,294" fill="var(--palette-neutral-lighten-2)" />

      {/* Step 5 */}
      <circle cx="420" cy="290" r="18" fill="var(--palette-positive)" opacity="0.15" />
      <text x="420" y="294" textAnchor="middle" fill="var(--palette-positive)" fontSize="12" fontWeight="700" fontFamily="Open Sans, sans-serif">5</text>
      <text x="420" y="316" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Logged in!")}</text>
    </svg>
  );
}

function InfographicRealtime() {
  const { t } = useTranslation();
  const stats = [
    { x: 60, label: "< 500ms", sub: t("Message delivery"), color: "var(--palette-primary)" },
    { x: 180, label: "< 1s", sub: t("History load (50 msgs)"), color: "var(--palette-positive)" },
    { x: 300, label: "2 GB", sub: t("Max file size"), color: "var(--palette-warning)" },
    { x: 420, label: "1000", sub: t("Members per group"), color: "var(--palette-negative)" },
  ];
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Real-time hub center */}
      <circle cx="260" cy="140" r="48" fill="var(--palette-primary)" opacity="0.06" stroke="var(--palette-primary)" strokeWidth="2" />
      <text x="260" y="134" textAnchor="middle" fill="var(--palette-primary)" fontSize="10" fontWeight="800" fontFamily="Open Sans, sans-serif">{t("Real-Time")}</text>
      <text x="260" y="150" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Hub")}</text>

      {/* Pulse rings */}
      <circle cx="260" cy="140" r="64" stroke="var(--palette-primary)" strokeWidth="1" opacity="0.15" fill="none" />
      <circle cx="260" cy="140" r="80" stroke="var(--palette-primary)" strokeWidth="0.5" opacity="0.08" fill="none" />

      {/* Connected nodes */}
      {/* Messages */}
      <rect x="16" y="40" width="120" height="48" rx="10" fill="var(--palette-main-bg)" />
      <circle cx="36" cy="64" r="10" fill="var(--palette-primary)" opacity="0.12" />
      <text x="36" y="67" textAnchor="middle" fontSize="10">&#128172;</text>
      <text x="52" y="60" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Messages")}</text>
      <text x="52" y="72" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Real-time delivery")}</text>
      <line x1="136" y1="64" x2="212" y2="120" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" />

      {/* Mentions */}
      <rect x="16" y="108" width="120" height="48" rx="10" fill="var(--palette-main-bg)" />
      <circle cx="36" cy="132" r="10" fill="var(--palette-warning)" opacity="0.12" />
      <text x="36" y="136" textAnchor="middle" fill="var(--palette-warning)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">@</text>
      <text x="52" y="128" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Mentions")}</text>
      <text x="52" y="140" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Instant @ alerts")}</text>
      <line x1="136" y1="132" x2="212" y2="138" stroke="var(--palette-warning)" strokeWidth="1.5" opacity="0.3" />

      {/* Online status */}
      <rect x="16" y="176" width="120" height="48" rx="10" fill="var(--palette-main-bg)" />
      <circle cx="36" cy="200" r="10" fill="var(--palette-positive)" opacity="0.12" />
      <circle cx="36" cy="200" r="4" fill="var(--palette-positive)" />
      <text x="52" y="196" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Online Status")}</text>
      <text x="52" y="208" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Presence tracking")}</text>
      <line x1="136" y1="200" x2="212" y2="158" stroke="var(--palette-positive)" strokeWidth="1.5" opacity="0.3" />

      {/* Reactions */}
      <rect x="384" y="40" width="120" height="48" rx="10" fill="var(--palette-main-bg)" />
      <circle cx="404" cy="64" r="10" fill="var(--palette-negative)" opacity="0.12" />
      <text x="404" y="68" textAnchor="middle" fontSize="10">&#128077;</text>
      <text x="420" y="60" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Reactions")}</text>
      <text x="420" y="72" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Live emoji updates")}</text>
      <line x1="384" y1="64" x2="308" y2="120" stroke="var(--palette-negative)" strokeWidth="1.5" opacity="0.3" />

      {/* Calls */}
      <rect x="384" y="108" width="120" height="48" rx="10" fill="var(--palette-main-bg)" />
      <circle cx="404" cy="132" r="10" fill="var(--palette-primary)" opacity="0.12" />
      <text x="404" y="136" textAnchor="middle" fontSize="10">&#128222;</text>
      <text x="420" y="128" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Calls")}</text>
      <text x="420" y="140" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Incoming ring")}</text>
      <line x1="384" y1="132" x2="308" y2="138" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" />

      {/* Push */}
      <rect x="384" y="176" width="120" height="48" rx="10" fill="var(--palette-main-bg)" />
      <circle cx="404" cy="200" r="10" fill="var(--palette-warning)" opacity="0.12" />
      <text x="404" y="204" textAnchor="middle" fontSize="10">&#128276;</text>
      <text x="420" y="196" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Push")}</text>
      <text x="420" y="208" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">iOS · Android · Web</text>
      <line x1="384" y1="200" x2="308" y2="158" stroke="var(--palette-warning)" strokeWidth="1.5" opacity="0.3" />

      {/* Bottom: stats bar */}
      <rect x="20" y="260" width="480" height="64" rx="12" fill="var(--palette-main-bg)" />
      {stats.map((s) => (
        <g key={s.label}>
          <text x={s.x} y="286" textAnchor="middle" fill={s.color} fontSize="18" fontWeight="800" fontFamily="Open Sans, sans-serif">{s.label}</text>
          <text x={s.x} y="302" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{s.sub}</text>
        </g>
      ))}
    </svg>
  );
}

function InfographicChannels() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Channel sidebar */}
      <rect x="0" y="0" width="160" height="340" rx="16" fill="var(--palette-main-bg)" />
      <rect x="160" y="0" width="1" height="340" fill="var(--palette-neutral-lighten-2)" />

      {/* Channel item 1 - active */}
      <rect x="8" y="16" width="144" height="52" rx="8" fill="var(--palette-primary)" opacity="0.1" />
      <rect x="14" y="28" width="28" height="28" rx="14" fill="var(--palette-primary)" opacity="0.2" />
      {/* Megaphone icon */}
      <text x="28" y="46" textAnchor="middle" fontSize="12">&#128227;</text>
      <text x="48" y="40" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Product News")}</text>
      <text x="48" y="52" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("{{count}} subscribers", { count: "1.2k" })}</text>

      {/* Channel item 2 */}
      <rect x="8" y="74" width="144" height="52" rx="8" fill="transparent" />
      <rect x="14" y="86" width="28" height="28" rx="14" fill="var(--palette-positive)" opacity="0.15" />
      <text x="28" y="104" textAnchor="middle" fontSize="12">&#128227;</text>
      <text x="48" y="98" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Engineering")}</text>
      <text x="48" y="110" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("{{count}} subscribers", { count: 340 })}</text>

      {/* Channel item 3 - group for contrast */}
      <rect x="8" y="132" width="144" height="52" rx="8" fill="transparent" />
      <circle cx="28" cy="158" r="14" fill="var(--palette-neutral)" opacity="0.12" />
      <text x="28" y="162" textAnchor="middle" fill="var(--palette-neutral)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">T</text>
      <text x="48" y="154" fill="var(--palette-foreground)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("Team Chat")}</text>
      <text x="48" y="166" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("{{count}} members", { count: 12 })}</text>

      {/* Chat area - broadcast messages */}
      {/* Owner badge header */}
      <rect x="172" y="12" width="340" height="32" rx="8" fill="var(--palette-primary)" opacity="0.06" />
      <text x="188" y="32" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">&#128227; {t("Product News")}</text>
      <text x="370" y="32" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("{{count}} subscribers", { count: "1,247" })}</text>

      {/* Broadcast message 1 */}
      <rect x="176" y="56" width="280" height="52" rx="12" fill="var(--palette-input-bg)" />
      <text x="188" y="72" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Admin")}</text>
      <text x="188" y="86" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("We just launched v2.5 with Channels!")}</text>
      <text x="188" y="100" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">10:30 AM</text>

      {/* Broadcast message 2 */}
      <rect x="176" y="118" width="310" height="64" rx="12" fill="var(--palette-input-bg)" />
      <text x="188" y="134" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Admin")}</text>
      <text x="188" y="150" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Key highlights of the release:")}</text>
      <text x="188" y="164" fill="var(--palette-foreground)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("- Broadcast channels for announcements")}</text>
      <text x="188" y="176" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">11:15 AM</text>

      {/* Read-only bar at bottom */}
      <rect x="172" y="296" width="340" height="32" rx="8" fill="var(--palette-main-bg)" />
      <text x="342" y="316" textAnchor="middle" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Only the channel owner can post here")}</text>

      {/* Decorative: subscriber count bubble */}
      <rect x="380" y="210" width="120" height="70" rx="12" fill="var(--palette-primary)" opacity="0.1" stroke="var(--palette-primary)" strokeWidth="1" />
      <text x="440" y="236" textAnchor="middle" fill="var(--palette-primary)" fontSize="22" fontWeight="800" fontFamily="Open Sans, sans-serif">1,247</text>
      <text x="440" y="254" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("subscribers reading")}</text>
    </svg>
  );
}

function InfographicLinkPreview() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Message with URL */}
      <rect x="24" y="20" width="280" height="36" rx="12" fill="var(--palette-input-bg)" />
      <text x="36" y="36" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">Sarah</text>
      <text x="36" y="48" fill="var(--palette-primary)" fontSize="9" fontFamily="Open Sans, sans-serif" textDecoration="underline">https://example.com/article</text>

      {/* Link preview card */}
      <rect x="24" y="62" width="280" height="140" rx="10" fill="var(--palette-main-bg)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      {/* Preview image area */}
      <rect x="24" y="62" width="280" height="80" rx="10" fill="var(--palette-primary)" opacity="0.08" />
      <rect x="24" y="132" width="280" height="10" fill="var(--palette-main-bg)" />
      {/* Image placeholder */}
      <rect x="120" y="82" width="68" height="40" rx="6" fill="var(--palette-primary)" opacity="0.12" />
      <text x="154" y="106" textAnchor="middle" fill="var(--palette-primary)" fontSize="16">&#127748;</text>
      {/* Preview text */}
      <text x="36" y="154" fill="var(--palette-foreground)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("How to Build Modern Chat Apps")}</text>
      <text x="36" y="168" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("A comprehensive guide to real-time messaging...")}</text>
      <text x="36" y="192" fill="var(--palette-primary)" fontSize="8" fontFamily="Open Sans, sans-serif">example.com</text>

      {/* Architecture diagram on the right */}
      {/* Server flow */}
      <rect x="340" y="30" width="150" height="36" rx="8" fill="var(--palette-primary)" opacity="0.08" />
      <text x="415" y="44" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("1. User sends URL")}</text>
      <text x="415" y="56" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("in message text")}</text>

      <line x1="415" y1="66" x2="415" y2="82" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" />
      <path d="M412 78L415 82L418 78" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" />

      <rect x="340" y="82" width="150" height="36" rx="8" fill="var(--palette-positive)" opacity="0.08" />
      <text x="415" y="96" textAnchor="middle" fill="var(--palette-positive)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("2. Preview pulled")}</text>
      <text x="415" y="108" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("title, image, description")}</text>

      <line x1="415" y1="118" x2="415" y2="134" stroke="var(--palette-positive)" strokeWidth="1.5" opacity="0.3" />
      <path d="M412 130L415 134L418 130" stroke="var(--palette-positive)" strokeWidth="1.5" opacity="0.3" />

      <rect x="340" y="134" width="150" height="36" rx="8" fill="var(--palette-warning)" opacity="0.08" />
      <text x="415" y="148" textAnchor="middle" fill="var(--palette-warning)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("3. Cached for speed")}</text>
      <text x="415" y="160" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Same link loads instantly")}</text>

      <line x1="415" y1="170" x2="415" y2="186" stroke="var(--palette-warning)" strokeWidth="1.5" opacity="0.3" />
      <path d="M412 182L415 186L418 182" stroke="var(--palette-warning)" strokeWidth="1.5" opacity="0.3" />

      <rect x="340" y="186" width="150" height="36" rx="8" fill="var(--palette-negative)" opacity="0.08" />
      <text x="415" y="200" textAnchor="middle" fill="var(--palette-negative)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("4. Preview rendered")}</text>
      <text x="415" y="212" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("title, desc, image, domain")}</text>

      {/* Safety note */}
      <rect x="340" y="240" width="150" height="44" rx="8" fill="var(--palette-primary)" opacity="0.06" stroke="var(--palette-primary)" strokeWidth="1" />
      <text x="415" y="256" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">&#128274; {t("Safe by default")}</text>
      <text x="415" y="270" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Blocks internal addresses")}</text>
      <text x="415" y="280" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Strict size + redirect limits")}</text>
    </svg>
  );
}

function InfographicMarkdown() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Left side: raw markdown input */}
      <text x="24" y="28" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("RAW INPUT")}</text>
      <rect x="16" y="38" width="230" height="280" rx="12" fill="var(--palette-main-bg)" />

      <text x="28" y="62" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">**bold text**</text>
      <text x="28" y="82" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">*italic text*</text>
      <text x="28" y="102" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">~~strikethrough~~</text>
      <text x="28" y="122" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">`inline code`</text>
      <text x="28" y="152" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">```</text>
      <text x="28" y="168" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">const x = 42;</text>
      <text x="28" y="184" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">```</text>
      <text x="28" y="214" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">&gt; blockquote text</text>
      <text x="28" y="244" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">@[123] mention user</text>

      {/* Arrow */}
      <line x1="256" y1="170" x2="274" y2="170" stroke="var(--palette-primary)" strokeWidth="2" />
      <path d="M270 166L276 170L270 174" stroke="var(--palette-primary)" strokeWidth="2" />

      {/* Right side: rendered output */}
      <text x="290" y="28" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("RENDERED")}</text>
      <rect x="282" y="38" width="222" height="280" rx="12" fill="var(--palette-main-bg)" />

      {/* Bold */}
      <text x="296" y="62" fill="var(--palette-foreground)" fontSize="11" fontWeight="800" fontFamily="Open Sans, sans-serif">{t("bold text")}</text>

      {/* Italic */}
      <text x="296" y="82" fill="var(--palette-foreground)" fontSize="11" fontStyle="italic" fontFamily="Open Sans, sans-serif">{t("italic text")}</text>

      {/* Strikethrough */}
      <text x="296" y="102" fill="var(--palette-neutral)" fontSize="11" textDecoration="line-through" fontFamily="Open Sans, sans-serif">{t("strikethrough")}</text>

      {/* Inline code */}
      <rect x="292" y="110" width="88" height="18" rx="3" fill="rgba(0,0,0,0.06)" />
      <text x="296" y="123" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">inline code</text>

      {/* Code block */}
      <rect x="292" y="138" width="200" height="50" rx="6" fill="rgba(0,0,0,0.06)" />
      <text x="302" y="158" fill="var(--palette-foreground)" fontSize="10" fontFamily="SF Mono, Consolas, monospace">const x = 42;</text>

      {/* Blockquote */}
      <rect x="292" y="200" width="3" height="20" rx="1" fill="var(--palette-primary)" />
      <text x="302" y="214" fill="var(--palette-neutral)" fontSize="11" fontStyle="italic" fontFamily="Open Sans, sans-serif">{t("blockquote text")}</text>

      {/* Mention */}
      <rect x="292" y="232" width="44" height="16" rx="4" fill="var(--palette-primary)" opacity="0.12" />
      <text x="296" y="244" fill="var(--palette-primary)" fontSize="10" fontWeight="600" fontFamily="Open Sans, sans-serif">@John</text>
      <text x="340" y="244" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif"> {t("mention user")}</text>

      {/* Supported formats label */}
      <rect x="292" y="268" width="200" height="40" rx="8" fill="var(--palette-primary)" opacity="0.06" stroke="var(--palette-primary)" strokeWidth="1" />
      <text x="392" y="284" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("7 formatting styles supported")}</text>
      <text x="392" y="298" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Works alongside @mentions and search highlights")}</text>
    </svg>
  );
}

/* ═══════════════════════════════════════════
   Infographic: Communication
   ═══════════════════════════════════════════ */

function InfographicCommunication() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 320" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 520 }}>
      {/* Background */}
      <rect width="520" height="320" rx="16" fill="var(--palette-input-bg)" />

      {/* Voice message bubble */}
      <rect x="24" y="20" width="220" height="52" rx="12" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <circle cx="50" cy="46" r="14" fill="var(--palette-primary)" />
      <polygon points="46,40 46,52 56,46" fill="white" />
      {/* Waveform bars */}
      {[0,1,2,3,4,5,6,7,8,9,10,11,12].map((i) => (
        <rect key={`w${i}`} x={74 + i * 10} y={38 - (6 + Math.sin(i * 0.9) * 5)} width={4} height={12 + Math.sin(i * 0.9) * 10} rx={2} fill={i < 7 ? "var(--palette-primary)" : "var(--palette-neutral-lighten-2)"} />
      ))}
      <text x="210" y="50" fill="var(--palette-neutral)" fontSize="10" textAnchor="end" fontFamily="Open Sans, sans-serif">0:12</text>
      <text x="28" y="16" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("VOICE MESSAGE")}</text>

      {/* Reply quote bubble */}
      <rect x="276" y="20" width="220" height="72" rx="12" fill="var(--palette-primary)" />
      {/* Quote accent */}
      <rect x="288" y="30" width="3" height="24" rx="1.5" fill="rgba(255,255,255,0.5)" />
      <text x="298" y="42" fill="rgba(255,255,255,0.8)" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">Alice</text>
      <text x="298" y="54" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Can we ship by Friday?")}</text>
      {/* Reply text */}
      <text x="288" y="78" fill="white" fontSize="11" fontFamily="Open Sans, sans-serif">{t("Yes, already pushed the fix!")}</text>
      <text x="280" y="16" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("REPLY")}</text>

      {/* Forward label bubble */}
      <rect x="24" y="92" width="220" height="56" rx="12" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="36" y="110" fill="var(--palette-neutral)" fontSize="9" fontStyle="italic" fontFamily="Open Sans, sans-serif">
        <tspan>&#x21AA; {t("Forwarded from Bob")}</tspan>
      </text>
      <text x="36" y="128" fill="var(--palette-foreground)" fontSize="11" fontFamily="Open Sans, sans-serif">{t("Check out this article!")}</text>
      <text x="28" y="88" fill="var(--palette-warning)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("FORWARD")}</text>

      {/* Typing indicator */}
      <rect x="276" y="100" width="180" height="40" rx="12" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="288" y="124" fill="var(--palette-primary)" fontSize="11" fontFamily="Open Sans, sans-serif">{t("Alice is typing")}</text>
      <circle cx="398" cy="120" r="3" fill="var(--palette-primary)" opacity="0.3" />
      <circle cx="410" cy="120" r="3" fill="var(--palette-primary)" opacity="0.6" />
      <circle cx="422" cy="120" r="3" fill="var(--palette-primary)" opacity="1" />
      <text x="280" y="96" fill="var(--palette-positive)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("TYPING")}</text>

      {/* Pinned message bar */}
      <rect x="24" y="168" width="472" height="40" rx="8" fill="var(--palette-primary)" opacity="0.08" stroke="var(--palette-primary)" strokeWidth="1" />
      <rect x="36" y="178" width="3" height="20" rx="1.5" fill="var(--palette-primary)" />
      {/* Pin icon */}
      <path d="M50 185v-5h.6v-1.2h-5.2v1.2h.6v5l-1.2 1.2v1.2h3.1v3.6h1v-3.6h3.1v-1.2l-1.2-1.2z" fill="var(--palette-primary)" transform="translate(0, -2)" />
      <text x="58" y="184" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Pinned message")}</text>
      <text x="58" y="198" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Meeting agenda: Review Q2 roadmap and assign tasks")}</text>
      <text x="28" y="164" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("PIN")}</text>

      {/* Delete placeholder */}
      <rect x="24" y="228" width="200" height="36" rx="12" fill="var(--palette-white)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" strokeDasharray="4 2" />
      <text x="124" y="250" textAnchor="middle" fill="var(--palette-neutral)" fontSize="10" fontStyle="italic" fontFamily="Open Sans, sans-serif">{t("This message was deleted")}</text>
      <text x="28" y="224" fill="var(--palette-negative)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("DELETE")}</text>

      {/* All-in-one badge */}
      <rect x="276" y="228" width="220" height="52" rx="12" fill="var(--palette-primary)" opacity="0.06" stroke="var(--palette-primary)" strokeWidth="1" />
      <text x="386" y="248" textAnchor="middle" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Everything in one bubble")}</text>
      <text x="386" y="264" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Reply, forward, voice, pin & delete — all in one place")}</text>
      <text x="386" y="276" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Same smooth experience across every device")}</text>
    </svg>
  );
}

function InfographicAdvancedCalls() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="#1a1e24" />

      {/* Main video area with virtual bg gradient */}
      <defs>
        <linearGradient id="vbg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
      </defs>
      <rect x="16" y="16" width="300" height="220" rx="10" fill="url(#vbg)" />

      {/* Person silhouette on virtual bg */}
      <circle cx="166" cy="100" r="35" fill="rgba(255,255,255,0.2)" />
      <path d="M136 170c0-16.57 13.43-30 30-30s30 13.43 30 30" fill="rgba(255,255,255,0.15)" />
      <text x="166" y="108" textAnchor="middle" fill="rgba(255,255,255,0.9)" fontSize="24" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("You")}</text>

      {/* Network quality badge */}
      <rect x="24" y="24" width="56" height="22" rx="6" fill="rgba(0,0,0,0.5)" />
      <rect x="32" y="36" width="3" height="4" rx="1" fill="#4caf50" />
      <rect x="37" y="33" width="3" height="7" rx="1" fill="#4caf50" />
      <rect x="42" y="30" width="3" height="10" rx="1" fill="#4caf50" />
      <rect x="47" y="27" width="3" height="13" rx="1" fill="#4caf50" />
      <rect x="52" y="24" width="3" height="16" rx="1" fill="rgba(255,255,255,0.2)" />
      <text x="62" y="39" fill="rgba(255,255,255,0.7)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Good")}</text>

      {/* PiP window */}
      <rect x="224" y="148" width="80" height="60" rx="6" fill="#2a2f38" stroke="var(--palette-primary)" strokeWidth="1.5" />
      <circle cx="264" cy="170" r="12" fill="var(--palette-positive)" opacity="0.3" />
      <text x="264" y="174" textAnchor="middle" fill="var(--palette-positive)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">SK</text>
      <text x="264" y="200" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="7" fontFamily="Open Sans, sans-serif">PiP</text>

      {/* REC indicator */}
      <circle cx="296" cy="28" r="6" fill="#ff4444" />
      <text x="282" y="32" fill="#fff" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">REC</text>

      {/* Incoming call modal (right side) */}
      <rect x="336" y="16" width="168" height="200" rx="12" fill="#2a2f38" />
      <text x="420" y="40" textAnchor="middle" fill="rgba(255,255,255,0.9)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Incoming Call")}</text>

      <circle cx="420" cy="80" r="24" fill="var(--palette-primary)" opacity="0.2" />
      <text x="420" y="86" textAnchor="middle" fill="var(--palette-primary)" fontSize="16" fontWeight="700" fontFamily="Open Sans, sans-serif">MR</text>
      <text x="420" y="118" textAnchor="middle" fill="rgba(255,255,255,0.8)" fontSize="10" fontFamily="Open Sans, sans-serif">Mike Ross</text>

      {/* Ringtone waves */}
      <path d="M380 72C376 66 376 58 380 52" stroke="var(--palette-primary)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <path d="M374 78C368 68 368 52 374 42" stroke="var(--palette-primary)" strokeWidth="1.5" strokeLinecap="round" opacity="0.25" />
      <path d="M460 72C464 66 464 58 460 52" stroke="var(--palette-primary)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <path d="M466 78C472 68 472 52 466 42" stroke="var(--palette-primary)" strokeWidth="1.5" strokeLinecap="round" opacity="0.25" />

      {/* Call buttons: Decline / Voice / Video */}
      <circle cx="380" cy="170" r="16" fill="var(--palette-negative)" />
      <text x="380" y="174" textAnchor="middle" fill="#fff" fontSize="10">&#10006;</text>

      <circle cx="420" cy="170" r="16" fill="var(--palette-primary)" />
      <text x="420" y="175" textAnchor="middle" fill="#fff" fontSize="12">&#128222;</text>

      <circle cx="460" cy="170" r="16" fill="var(--palette-positive)" />
      <text x="460" y="175" textAnchor="middle" fill="#fff" fontSize="12">&#128249;</text>

      <text x="380" y="198" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Decline")}</text>
      <text x="420" y="198" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Voice")}</text>
      <text x="460" y="198" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Video")}</text>

      {/* Controls bar at bottom */}
      <rect x="16" y="248" width="488" height="40" rx="8" fill="#2a2f38" />

      {/* Background selector popup */}
      <rect x="80" y="256" width="24" height="24" rx="4" fill="transparent" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
      <text x="92" y="272" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="7">BG</text>

      {/* Controls */}
      <circle cx="200" cy="268" r="10" fill="var(--palette-positive)" opacity="0.8" />
      <circle cx="230" cy="268" r="10" fill="rgba(255,255,255,0.15)" />
      <circle cx="260" cy="268" r="10" fill="rgba(255,255,255,0.15)" />
      <circle cx="290" cy="268" r="10" fill="rgba(255,255,255,0.15)" />
      <circle cx="320" cy="268" r="10" fill="var(--palette-negative)" />

      {/* PiP toggle */}
      <rect x="380" y="258" width="24" height="20" rx="4" fill="transparent" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
      <rect x="388" y="264" width="12" height="8" rx="2" fill="rgba(255,255,255,0.3)" />

      {/* Reconnection banner */}
      <rect x="16" y="296" width="488" height="28" rx="6" fill="#ff9800" opacity="0.15" />
      <text x="260" y="314" textAnchor="middle" fill="#ff9800" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">&#9888; {t("Reconnecting... attempt 2/5 (2s)")}</text>
    </svg>
  );
}

function InfographicSmartRecording() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Left: recording compositing */}
      <text x="16" y="28" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("COMPOSITED RECORDING")}</text>

      <rect x="16" y="38" width="230" height="160" rx="8" fill="#1a1e24" />
      {/* Grid layout */}
      <rect x="22" y="44" width="108" height="72" rx="4" fill="#2a2f38" />
      <rect x="134" y="44" width="108" height="72" rx="4" fill="#2a2f38" />
      <rect x="22" y="120" width="108" height="72" rx="4" fill="#2a2f38" />
      <rect x="134" y="120" width="108" height="72" rx="4" fill="#2a2f38" stroke="var(--palette-primary)" strokeWidth="1" />

      {/* Avatars */}
      <circle cx="76" cy="72" r="14" fill="var(--palette-primary)" opacity="0.3" />
      <text x="76" y="76" textAnchor="middle" fill="var(--palette-primary)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">DP</text>
      <circle cx="188" cy="72" r="14" fill="var(--palette-positive)" opacity="0.3" />
      <text x="188" y="76" textAnchor="middle" fill="var(--palette-positive)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">SK</text>
      <circle cx="76" cy="148" r="14" fill="var(--palette-warning)" opacity="0.3" />
      <text x="76" y="152" textAnchor="middle" fill="var(--palette-warning)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">MR</text>
      <circle cx="188" cy="148" r="14" fill="var(--palette-negative)" opacity="0.3" />
      <text x="188" y="152" textAnchor="middle" fill="var(--palette-negative)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">AJ</text>

      {/* REC badge */}
      <circle cx="228" cy="50" r="5" fill="#ff4444" />
      <text x="214" y="53" fill="#fff" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">REC</text>

      {/* Browser compatibility badges */}
      <text x="16" y="220" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Compatible:")}</text>
      <rect x="80" y="211" width="46" height="16" rx="8" fill="var(--palette-primary)" opacity="0.1" />
      <text x="103" y="223" textAnchor="middle" fill="var(--palette-primary)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">Chrome</text>
      <rect x="130" y="211" width="42" height="16" rx="8" fill="var(--palette-positive)" opacity="0.1" />
      <text x="151" y="223" textAnchor="middle" fill="var(--palette-positive)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">Safari</text>
      <rect x="176" y="211" width="44" height="16" rx="8" fill="var(--palette-warning)" opacity="0.1" />
      <text x="198" y="223" textAnchor="middle" fill="var(--palette-warning)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">Firefox</text>

      {/* Right: storage flow */}
      <text x="280" y="28" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("STORAGE & METADATA")}</text>

      {/* Upload flow */}
      <rect x="280" y="40" width="220" height="40" rx="8" fill="var(--palette-primary)" opacity="0.06" />
      <text x="390" y="56" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("1. Client records & uploads")}</text>
      <text x="390" y="70" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("HD video + audio, up to 2 GB")}</text>

      <line x1="390" y1="80" x2="390" y2="96" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" />
      <path d="M387 92L390 96L393 92" stroke="var(--palette-primary)" strokeWidth="1.5" opacity="0.3" />

      <rect x="280" y="96" width="220" height="40" rx="8" fill="var(--palette-positive)" opacity="0.06" />
      <text x="390" y="112" textAnchor="middle" fill="var(--palette-positive)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("2. Server stores securely")}</text>
      <text x="390" y="126" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Encrypted, range-seekable")}</text>

      <line x1="390" y1="136" x2="390" y2="152" stroke="var(--palette-positive)" strokeWidth="1.5" opacity="0.3" />
      <path d="M387 148L390 152L393 148" stroke="var(--palette-positive)" strokeWidth="1.5" opacity="0.3" />

      <rect x="280" y="152" width="220" height="40" rx="8" fill="var(--palette-warning)" opacity="0.06" />
      <text x="390" y="168" textAnchor="middle" fill="var(--palette-warning)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("3. Metadata saved")}</text>
      <text x="390" y="182" textAnchor="middle" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("conferenceId, participants, duration")}</text>

      <line x1="390" y1="192" x2="390" y2="208" stroke="var(--palette-warning)" strokeWidth="1.5" opacity="0.3" />
      <path d="M387 204L390 208L393 204" stroke="var(--palette-warning)" strokeWidth="1.5" opacity="0.3" />

      {/* Inline preview card */}
      <rect x="280" y="208" width="220" height="80" rx="8" fill="var(--palette-main-bg)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="390" y="226" textAnchor="middle" fill="var(--palette-foreground)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("4. Inline chat preview")}</text>

      {/* Mini preview player */}
      <rect x="310" y="236" width="100" height="42" rx="6" fill="#1a1e24" />
      <circle cx="360" cy="257" r="10" fill="rgba(255,255,255,0.3)" />
      <path d="M356 253V261L364 257Z" fill="#fff" />
      <rect x="418" y="240" width="70" height="8" rx="4" fill="var(--palette-neutral)" opacity="0.3" />
      <rect x="418" y="254" width="50" height="6" rx="3" fill="var(--palette-neutral)" opacity="0.2" />
      <rect x="418" y="266" width="60" height="8" rx="4" fill="var(--palette-primary)" opacity="0.15" />
      <text x="448" y="274" textAnchor="middle" fill="var(--palette-primary)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("Download")}</text>

      {/* Retention note */}
      <rect x="280" y="300" width="220" height="28" rx="6" fill="var(--palette-primary)" opacity="0.05" stroke="var(--palette-primary)" strokeWidth="0.5" />
      <text x="390" y="318" textAnchor="middle" fill="var(--palette-primary)" fontSize="8" fontFamily="Open Sans, sans-serif">&#128274; {t("Auto-cleanup: 7 day retention")}</text>

      {/* Bottom left: sub-thread illustration */}
      <text x="16" y="250" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("MESSAGE THREADS")}</text>

      <rect x="16" y="260" width="110" height="28" rx="8" fill="var(--palette-input-bg)" />
      <text x="26" y="278" fill="var(--palette-foreground)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Ship today?")} &#128172; 3</text>

      <rect x="136" y="260" width="100" height="68" rx="8" fill="var(--palette-main-bg)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="146" y="276" fill="var(--palette-primary)" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Thread")}</text>
      <rect x="146" y="282" width="80" height="12" rx="4" fill="var(--palette-input-bg)" />
      <text x="152" y="292" fill="var(--palette-neutral)" fontSize="6" fontFamily="Open Sans, sans-serif">{t("Yes, PR merged")}</text>
      <rect x="146" y="298" width="80" height="12" rx="4" fill="var(--palette-primary)" opacity="0.12" />
      <text x="152" y="308" fill="var(--palette-foreground)" fontSize="6" fontFamily="Open Sans, sans-serif">{t("LGTM, deploying")}</text>
      <rect x="146" y="314" width="80" height="10" rx="5" fill="var(--palette-input-bg)" />
      <text x="152" y="322" fill="var(--palette-neutral)" fontSize="6" fontFamily="Open Sans, sans-serif">{t("Reply...")}</text>
    </svg>
  );
}

function InfographicChatFolders() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Sidebar panel */}
      <rect x="16" y="16" width="200" height="308" rx="12" fill="var(--palette-main-bg)" />

      {/* Search bar */}
      <rect x="28" y="28" width="176" height="28" rx="14" fill="var(--palette-input-bg)" />
      <text x="48" y="47" fill="var(--palette-neutral)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Search...")}</text>

      {/* Folder tabs */}
      <text x="28" y="76" fill="var(--palette-neutral)" fontSize="8" fontWeight="700" letterSpacing="1" fontFamily="Open Sans, sans-serif">{t("FOLDER TABS")}</text>
      <rect x="28" y="82" width="36" height="20" rx="10" fill="var(--palette-primary)" />
      <text x="36" y="96" fill="#fff" fontSize="9" fontWeight="600" fontFamily="Open Sans, sans-serif">{t("All")}</text>
      <rect x="68" y="82" width="48" height="20" rx="10" fill="var(--palette-input-bg)" />
      <text x="76" y="96" fill="var(--palette-foreground)" fontSize="9" fontWeight="500" fontFamily="Open Sans, sans-serif">{t("Work")}</text>
      <circle cx="108" cy="92" r="7" fill="var(--palette-negative)" />
      <text x="105" y="95" fill="#fff" fontSize="7" fontWeight="700" fontFamily="Open Sans, sans-serif">3</text>
      <rect x="120" y="82" width="58" height="20" rx="10" fill="var(--palette-input-bg)" />
      <text x="128" y="96" fill="var(--palette-foreground)" fontSize="9" fontWeight="500" fontFamily="Open Sans, sans-serif">{t("Friends")}</text>
      <rect x="182" y="82" width="20" height="20" rx="10" fill="var(--palette-input-bg)" />
      <text x="189" y="96" fill="var(--palette-neutral)" fontSize="12" fontFamily="Open Sans, sans-serif">+</text>

      {/* Chat list items */}
      {[0, 1, 2, 3].map((i) => (
        <g key={i} transform={`translate(0, ${i * 48})`}>
          <rect x="28" y="112" width="176" height="42" rx="8" fill={i === 0 ? "rgba(55,168,255,0.1)" : "transparent"} />
          <circle cx="46" cy="133" r="14" fill={i === 0 ? "var(--palette-primary)" : "var(--palette-neutral)"} opacity={i === 0 ? 1 : 0.3} />
          <text x="42" y="137" fill="#fff" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">{["A", "D", "M", "S"][i]}</text>
          <rect x="66" y="124" width={[70, 55, 64, 50][i]} height="8" rx="4" fill="var(--palette-foreground)" opacity={i === 0 ? 0.9 : 0.5} />
          <rect x="66" y="136" width={[100, 80, 90, 75][i]} height="6" rx="3" fill="var(--palette-neutral)" opacity="0.4" />
          {i === 0 && <circle cx="190" cy="133" r="8" fill="var(--palette-primary)" />}
          {i === 0 && <text x="187" y="137" fill="#fff" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">2</text>}
        </g>
      ))}

      {/* Right side: context menu illustration */}
      <rect x="240" y="16" width="264" height="308" rx="12" fill="var(--palette-main-bg)" />
      <text x="260" y="40" fill="var(--palette-primary)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("RIGHT-CLICK MENU")}</text>

      {/* Context menu */}
      <rect x="260" y="52" width="160" height="140" rx="10" fill="var(--palette-white)" stroke="var(--palette-neutral)" strokeWidth="0.5" />

      {/* Folder submenu item — short label so the row + arrow fits in 144px even
          when localised (e.g. RU "В папку" instead of full "Добавить в папку"). */}
      <rect x="268" y="60" width="144" height="28" rx="6" fill="rgba(55,168,255,0.08)" />
      <path d="M280 69C280 67.34 281.34 66 283 66H289L291 68H297C298.66 68 300 69.34 300 71V79C300 80.66 298.66 82 297 82H283C281.34 82 280 80.66 280 79V69Z" fill="var(--palette-primary)" opacity="0.8" />
      <text x="306" y="78" fill="var(--palette-foreground)" fontSize="10" fontWeight="500" fontFamily="Open Sans, sans-serif">{t("To folder")}</text>
      <text x="398" y="78" fill="var(--palette-neutral)" fontSize="10" fontFamily="Open Sans, sans-serif">&#x25B8;</text>

      {/* Submenu expanded */}
      <rect x="340" y="90" width="150" height="120" rx="8" fill="var(--palette-white)" stroke="var(--palette-neutral)" strokeWidth="0.5" />

      {/* Folder items with checkboxes */}
      {[t("Work"), t("Personal"), t("Projects")].map((name, i) => (
        <g key={name} transform={`translate(0, ${i * 30})`}>
          <rect x="352" y="98" width="14" height="14" rx="3" fill={i < 2 ? "var(--palette-primary)" : "transparent"} stroke={i < 2 ? "var(--palette-primary)" : "var(--palette-neutral)"} strokeWidth="1.5" />
          {i < 2 && <path d={`M355 ${105}L358 ${108}L363 ${102}`} stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />}
          <text x="372" y="109" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{name}</text>
        </g>
      ))}

      {/* New folder link */}
      <text x="352" y="198" fill="var(--palette-primary)" fontSize="10" fontWeight="500" fontFamily="Open Sans, sans-serif">+ {t("New folder")}...</text>

      {/* Other menu items — short labels (e.g. "Leave" not "Leave Group", "Hide"
          not "Hide Chat") so RU text doesn't overlap the cascading submenu that
          starts at x=340. */}
      <line x1="268" y1="94" x2="404" y2="94" stroke="var(--palette-neutral)" strokeWidth="0.5" opacity="0.3" />
      <text x="280" y="112" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Leave")}</text>
      <text x="280" y="136" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Hide")}</text>

      {/* Bottom label */}
      <text x="260" y="280" fill="var(--palette-neutral)" fontSize="8" fontWeight="700" letterSpacing="1" fontFamily="Open Sans, sans-serif">{t("CROSS-DEVICE SYNC")}</text>
      <rect x="260" y="288" width="224" height="24" rx="6" fill="rgba(55,168,255,0.06)" />
      <text x="272" y="304" fill="var(--palette-primary)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Your folders follow you everywhere")}</text>
    </svg>
  );
}

function InfographicNativeCalls() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="#0b1020" />
      {/* Caller side (left) */}
      <text x="24" y="32" fill="#9aa3b2" fontSize="11" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("CALLER")}</text>
      <rect x="24" y="44" width="140" height="220" rx="22" fill="#1a2238" stroke="#2e3a5c" strokeWidth="2" />
      <rect x="32" y="52" width="124" height="204" rx="16" fill="#0f1628" />
      <circle cx="94" cy="100" r="24" fill="#3b82f6" opacity="0.3" />
      <text x="94" y="106" textAnchor="middle" fill="#3b82f6" fontSize="14" fontWeight="700" fontFamily="Open Sans, sans-serif">YP</text>
      <text x="94" y="146" textAnchor="middle" fill="#e6eaf2" fontSize="12" fontFamily="Open Sans, sans-serif" fontWeight="600">{t("Calling...")}</text>
      <text x="94" y="162" textAnchor="middle" fill="#9aa3b2" fontSize="10" fontFamily="Open Sans, sans-serif">Alice Smith</text>
      <circle cx="70" cy="220" r="16" fill="#dc2626" />
      <path d="M62 216l16 8M62 224l16 -8" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
      <circle cx="118" cy="220" r="16" fill="#16a34a" />
      <path d="M110 218c4 -4 12 -4 16 0M112 222c3 -3 7 -3 12 0" stroke="#fff" strokeWidth="2" strokeLinecap="round" fill="none" />

      {/* Flow arrows */}
      <g stroke="#3b82f6" strokeWidth="2" fill="none">
        <path d="M172 120 L 220 120" markerEnd="url(#arrow)" />
        <path d="M304 120 L 352 120" markerEnd="url(#arrow)" />
      </g>
      <defs>
        <marker id="arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0 0 L10 5 L0 10 Z" fill="#3b82f6" />
        </marker>
      </defs>

      {/* Server block (center) */}
      <rect x="220" y="76" width="84" height="96" rx="12" fill="#1e293b" stroke="#475569" strokeWidth="1.5" />
      <text x="262" y="96" textAnchor="middle" fill="#e6eaf2" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Server")}</text>
      <text x="262" y="112" textAnchor="middle" fill="#9aa3b2" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Incoming call")}</text>
      <rect x="228" y="120" width="68" height="16" rx="4" fill="#3b82f6" opacity="0.2" />
      <text x="262" y="132" textAnchor="middle" fill="#3b82f6" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("Push to iPhone")}</text>
      <rect x="228" y="142" width="68" height="16" rx="4" fill="#8b5cf6" opacity="0.2" />
      <text x="262" y="154" textAnchor="middle" fill="#8b5cf6" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("Apple-certified")}</text>

      <text x="200" y="200" fill="#9aa3b2" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Voice-call push")}</text>
      <text x="196" y="214" fill="#9aa3b2" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Reserved channel")}</text>
      <text x="196" y="226" fill="#9aa3b2" fontSize="8" fontFamily="Open Sans, sans-serif">{t("Rings within seconds")}</text>

      {/* Apple Push */}
      <rect x="318" y="100" width="36" height="40" rx="6" fill="#475569" />
      <text x="336" y="124" textAnchor="middle" fill="#fff" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">Apple</text>
      <text x="336" y="136" textAnchor="middle" fill="#fff" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Push")}</text>

      {/* Callee (right) — LOCKED iPhone */}
      <text x="496" y="32" textAnchor="end" fill="#9aa3b2" fontSize="11" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("CALLEE (LOCKED)")}</text>
      <rect x="356" y="44" width="140" height="270" rx="22" fill="#1a2238" stroke="#2e3a5c" strokeWidth="2" />
      <rect x="364" y="52" width="124" height="254" rx="16" fill="#000" />

      {/* Lock-screen time */}
      <text x="426" y="78" textAnchor="middle" fill="#fff" fontSize="11" fontFamily="Open Sans, sans-serif" opacity="0.6">9:41</text>

      {/* Native incoming-call screen */}
      <rect x="372" y="92" width="108" height="206" rx="14" fill="#1c1c1e" stroke="#3a3a3c" strokeWidth="1" />
      <text x="426" y="112" textAnchor="middle" fill="#fff" fontSize="9" fontFamily="Open Sans, sans-serif" opacity="0.5">SMeet Video</text>
      <circle cx="426" cy="148" r="22" fill="#3b82f6" opacity="0.3" />
      <text x="426" y="154" textAnchor="middle" fill="#3b82f6" fontSize="13" fontWeight="700" fontFamily="Open Sans, sans-serif">YP</text>
      <text x="426" y="188" textAnchor="middle" fill="#fff" fontSize="13" fontFamily="Open Sans, sans-serif" fontWeight="600">Yury P.</text>
      <text x="426" y="202" textAnchor="middle" fill="#fff" fontSize="9" fontFamily="Open Sans, sans-serif" opacity="0.5">{t("incoming call")}</text>

      {/* Accept/Decline buttons */}
      <circle cx="396" cy="254" r="14" fill="#ef4444" />
      <path d="M390 252l12 4M390 256l12 -4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
      <text x="396" y="284" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Open Sans, sans-serif" opacity="0.8">{t("Decline")}</text>
      <circle cx="456" cy="254" r="14" fill="#22c55e" />
      <path d="M450 252c3 -3 9 -3 12 0M452 256c2 -2 6 -2 8 0" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" fill="none" />
      <text x="456" y="284" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Open Sans, sans-serif" opacity="0.8">{t("Accept")}</text>

      {/* "even when killed" badge */}
      <rect x="364" y="318" width="124" height="14" rx="7" fill="#16a34a" opacity="0.2" />
      <text x="426" y="328" textAnchor="middle" fill="#22c55e" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("Works even when app is KILLED")}</text>
    </svg>
  );
}

function InfographicConferenceTranscription() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Left: Audio tracks per speaker */}
      <text x="20" y="28" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("PER-SPEAKER AUDIO")}</text>

      {[
        { y: 44, name: "Anton",  color: "#4c83ff" },
        { y: 78, name: "Maria",  color: "var(--palette-positive)" },
        { y: 112, name: "Lena",  color: "var(--palette-warning)" },
        { y: 146, name: "Dmitry", color: "var(--palette-negative)" },
      ].map((s, idx) => (
        <g key={s.name}>
          <circle cx="36" cy={s.y + 14} r="13" fill={s.color} opacity="0.25" />
          <text x="36" y={s.y + 18} textAnchor="middle" fill={s.color} fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">{s.name[0]}</text>
          <text x="56" y={s.y + 12} fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{s.name}</text>
          <rect x="56" y={s.y + 18} width="160" height="10" rx="3" fill="rgba(0,0,0,0.04)" />
          {/* waveform bars */}
          {Array.from({ length: 28 }, (_, i) => {
            const h = 4 + ((i * 7 + idx * 3) % 8);
            return (
              <rect key={i} x={58 + i * 5.6} y={s.y + 23 - h / 2} width="3" height={h} rx="1" fill={s.color} opacity={0.4 + ((i * 11 + idx) % 4) * 0.15} />
            );
          })}
        </g>
      ))}

      {/* Arrow to AI transcribe */}
      <line x1="220" y1="100" x2="252" y2="100" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.4" />
      <path d="M248 96L252 100L248 104" stroke="var(--palette-neutral)" strokeWidth="1.5" opacity="0.4" />

      {/* AI Transcribe box */}
      <rect x="252" y="68" width="92" height="60" rx="10" fill="#1a1e24" />
      <text x="298" y="88" textAnchor="middle" fill="#fff" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("AI Transcribe")}</text>
      <text x="298" y="104" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("99 languages")}</text>
      <text x="298" y="118" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("privately hosted")}</text>

      {/* Arrow to transcript */}
      <line x1="346" y1="100" x2="376" y2="100" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.4" />
      <path d="M372 96L376 100L372 104" stroke="var(--palette-neutral)" strokeWidth="1.5" opacity="0.4" />

      {/* Right: Transcript output */}
      <rect x="376" y="20" width="128" height="160" rx="10" fill="var(--palette-main-bg)" stroke="rgba(0,0,0,0.05)" strokeWidth="1" />
      <text x="386" y="38" fill="var(--palette-neutral)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("TRANSCRIPT")}</text>

      {[
        { y: 50, name: "Anton",  ts: "00:12", color: "#4c83ff" },
        { y: 78, name: "Maria",  ts: "00:17", color: "var(--palette-positive)" },
        { y: 106, name: "Anton", ts: "00:22", color: "#4c83ff" },
        { y: 134, name: "Lena",  ts: "00:31", color: "var(--palette-warning)" },
      ].map((row, i) => (
        <g key={i}>
          <text x="386" y={row.y + 8} fill={row.color} fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{row.name}</text>
          <text x="466" y={row.y + 8} textAnchor="end" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{row.ts}</text>
          <rect x="386" y={row.y + 12} width={70 + (i * 9) % 25} height="4" rx="2" fill="var(--palette-foreground)" opacity="0.5" />
          <rect x="386" y={row.y + 18} width={50 + (i * 13) % 30} height="4" rx="2" fill="var(--palette-foreground)" opacity="0.3" />
        </g>
      ))}

      {/* Bottom row: capabilities */}
      <text x="20" y="216" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("PIPELINE")}</text>

      <rect x="20" y="226" width="148" height="44" rx="8" fill="rgba(108, 63, 196, 0.06)" />
      <text x="94" y="244" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Auto on stop")}</text>
      <text x="94" y="258" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("queue → segments → store")}</text>

      <rect x="180" y="226" width="148" height="44" rx="8" fill="rgba(76, 131, 255, 0.06)" />
      <text x="254" y="244" textAnchor="middle" fill="#1c7ed6" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Pollable status")}</text>
      <text x="254" y="258" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("pending → running → done")}</text>

      <rect x="340" y="226" width="160" height="44" rx="8" fill="rgba(34, 197, 94, 0.06)" />
      <text x="420" y="244" textAnchor="middle" fill="var(--palette-positive)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Export .txt / .srt")}</text>
      <text x="420" y="258" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("timestamped, downloadable")}</text>

      {/* Privacy badge */}
      <rect x="20" y="288" width="480" height="36" rx="10" fill="rgba(0,0,0,0.04)" />
      <text x="36" y="310" fill="var(--palette-foreground)" fontSize="11">🔒</text>
      <text x="56" y="304" fill="var(--palette-foreground)" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Privacy by design")}</text>
      <text x="56" y="316" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Audio never leaves your servers — no external API calls, no quotas, no per-minute pricing.")}</text>
    </svg>
  );
}

function InfographicVoiceClone() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Top — enrollment */}
      <text x="20" y="28" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("1 · ENROLL ONCE (30s)")}</text>

      <rect x="20" y="38" width="220" height="106" rx="10" fill="var(--palette-main-bg)" />
      <text x="36" y="58" fill="var(--palette-foreground)" fontSize="14">🎙</text>
      <text x="56" y="58" fill="var(--palette-foreground)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Read 5 sentences")}</text>
      <text x="36" y="78" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("“Hi, my name is here, and I work…”")}</text>
      <text x="36" y="92" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("“Today the weather is calm…”")}</text>
      <text x="36" y="106" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("“We discussed important questions…”")}</text>

      {/* recording timer */}
      <rect x="36" y="118" width="188" height="18" rx="9" fill="rgba(76, 131, 255, 0.1)" />
      <circle cx="48" cy="127" r="4" fill="#e74c3c" />
      <text x="60" y="131" fill="#1c7ed6" fontSize="10" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("Recording 21.3s / 60s")}</text>

      {/* arrow to embedding */}
      <line x1="240" y1="92" x2="270" y2="92" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.4" />
      <path d="M266 88L270 92L266 96" stroke="var(--palette-neutral)" strokeWidth="1.5" opacity="0.4" />

      <rect x="270" y="64" width="100" height="56" rx="10" fill="#1a1e24" />
      <text x="320" y="84" textAnchor="middle" fill="#fff" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Voice Clone AI")}</text>
      <text x="320" y="100" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("privately hosted")}</text>
      <text x="320" y="112" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("no third-party calls")}</text>

      <line x1="370" y1="92" x2="396" y2="92" stroke="var(--palette-neutral)" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.4" />
      <path d="M392 88L396 92L392 96" stroke="var(--palette-neutral)" strokeWidth="1.5" opacity="0.4" />

      <rect x="396" y="64" width="104" height="56" rx="10" fill="rgba(46, 184, 92, 0.08)" stroke="rgba(46, 184, 92, 0.3)" strokeWidth="1" />
      <text x="448" y="83" textAnchor="middle" fill="#2eb85c" fontSize="11" fontFamily="Open Sans, sans-serif">🔒</text>
      <text x="448" y="100" textAnchor="middle" fill="#2eb85c" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Voice profile")}</text>
      <text x="448" y="112" textAnchor="middle" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif">{t("on-prem only")}</text>

      {/* Divider */}
      <line x1="20" y1="160" x2="500" y2="160" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" strokeDasharray="3 3" />

      {/* Bottom — playback */}
      <text x="20" y="184" fill="var(--palette-foreground)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">{t("2 · TRANSLATE EVERY VOICE MESSAGE — IN YOUR VOICE")}</text>

      {/* Original message */}
      <rect x="20" y="200" width="220" height="64" rx="14" fill="var(--palette-input-bg)" />
      <circle cx="40" cy="232" r="14" fill="#4c83ff" opacity="0.3" />
      <text x="40" y="236" textAnchor="middle" fill="#4c83ff" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">A</text>
      <circle cx="64" cy="232" r="9" fill="#4c83ff" />
      <path d="M62 230v4l3 -2z" fill="#fff" />
      {/* waveform bars */}
      {Array.from({ length: 18 }, (_, i) => {
        const h = 4 + (i * 7) % 12;
        return <rect key={i} x={80 + i * 6} y={232 - h / 2} width="3" height={h} rx="1" fill="#4c83ff" opacity={0.4 + ((i * 5) % 4) * 0.15} />;
      })}
      <rect x="20" y="200" width="220" height="64" rx="14" fill="none" stroke="rgba(76, 131, 255, 0.25)" strokeWidth="1" />
      <text x="36" y="220" fill="var(--palette-neutral)" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">Anton · 0:14 · RU</text>

      {/* Language picker chips */}
      <text x="20" y="284" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("LANG TOGGLE")}</text>
      {[
        { x: 20, lab: t("Original"), active: false },
        { x: 80, lab: "EN", active: true },
        { x: 130, lab: "ES", active: false },
        { x: 178, lab: "DE", active: false },
        { x: 226, lab: "FR", active: false },
      ].map((c) => (
        <g key={c.lab}>
          <rect x={c.x} y={290} width={c.lab.length > 2 ? 50 : 40} height={20} rx={10}
                fill={c.active ? "rgba(108, 63, 196, 0.15)" : "transparent"}
                stroke={c.active ? "transparent" : "rgba(0,0,0,0.1)"} strokeWidth={1} />
          <text x={c.x + (c.lab.length > 2 ? 25 : 20)} y={304} textAnchor="middle"
                fill={c.active ? "#6c3fc4" : "var(--palette-neutral)"}
                fontSize="9" fontWeight={c.active ? "700" : "400"} fontFamily="Open Sans, sans-serif">{c.lab}</text>
        </g>
      ))}

      {/* Translated playback */}
      <line x1="248" y1="232" x2="278" y2="232" stroke="#6c3fc4" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.5" />
      <path d="M274 228L278 232L274 236" stroke="#6c3fc4" strokeWidth="1.5" opacity="0.5" />

      <rect x="280" y="200" width="220" height="64" rx="14" fill="rgba(108, 63, 196, 0.08)" stroke="rgba(108, 63, 196, 0.3)" strokeWidth="1" />
      <circle cx="300" cy="232" r="14" fill="#6c3fc4" opacity="0.3" />
      <text x="300" y="236" textAnchor="middle" fill="#6c3fc4" fontSize="10" fontWeight="700" fontFamily="Open Sans, sans-serif">A</text>
      <circle cx="324" cy="232" r="9" fill="#6c3fc4" />
      <path d="M322 230v4l3 -2z" fill="#fff" />
      {Array.from({ length: 18 }, (_, i) => {
        const h = 4 + ((i * 11) % 12);
        return <rect key={i} x={340 + i * 6} y={232 - h / 2} width="3" height={h} rx="1" fill="#6c3fc4" opacity={0.4 + ((i * 7) % 4) * 0.15} />;
      })}
      <text x="296" y="220" fill="#6c3fc4" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("Anton (EN) · in his own voice")}</text>

      {/* Privacy badge bottom-right */}
      <rect x="380" y="284" width="120" height="36" rx="10" fill="rgba(0,0,0,0.04)" />
      <text x="392" y="306" fill="var(--palette-foreground)" fontSize="11">🔐</text>
      <text x="412" y="299" fill="var(--palette-foreground)" fontSize="8" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Consent + delete")}</text>
      <text x="412" y="312" fill="var(--palette-neutral)" fontSize="7" fontFamily="Open Sans, sans-serif">{t("GDPR-friendly")}</text>
    </svg>
  );
}

function InfographicMeetingCoach() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Header */}
      <text x="20" y="32" fill="var(--palette-foreground)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="1">📊  {t("AI MEETING SUMMARY")}</text>
      <rect x="430" y="20" width="74" height="20" rx="10" fill="rgba(108, 63, 196, 0.1)" />
      <text x="467" y="33" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("45m · 5 ppl")}</text>

      {/* Executive summary */}
      <rect x="20" y="50" width="484" height="46" rx="8" fill="var(--palette-main-bg)" />
      <text x="32" y="68" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("SUMMARY")}</text>
      <text x="32" y="84" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Q3 budget approved at -15%. Stripe integration assigned to Maria.")}</text>

      {/* Topics */}
      <text x="20" y="118" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("TOPICS")}</text>
      <rect x="20" y="124" width="62" height="20" rx="10" fill="rgba(108, 63, 196, 0.1)" />
      <text x="51" y="138" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontFamily="Open Sans, sans-serif">{t("budget")}</text>
      <rect x="86" y="124" width="60" height="20" rx="10" fill="rgba(108, 63, 196, 0.1)" />
      <text x="116" y="138" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontFamily="Open Sans, sans-serif">{t("release")}</text>
      <rect x="150" y="124" width="56" height="20" rx="10" fill="rgba(108, 63, 196, 0.1)" />
      <text x="178" y="138" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontFamily="Open Sans, sans-serif">Stripe</text>
      <rect x="210" y="124" width="50" height="20" rx="10" fill="rgba(108, 63, 196, 0.1)" />
      <text x="235" y="138" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontFamily="Open Sans, sans-serif">{t("hiring")}</text>

      {/* Decisions */}
      <text x="20" y="170" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("DECISIONS")}</text>
      <circle cx="26" cy="184" r="2" fill="var(--palette-positive)" />
      <text x="34" y="187" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Release 2.5 → Friday")}</text>
      <circle cx="26" cy="200" r="2" fill="var(--palette-positive)" />
      <text x="34" y="203" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("Cut marketing budget by 15%")}</text>

      {/* Action items */}
      <text x="270" y="170" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("ACTION ITEMS")}</text>
      <rect x="270" y="178" width="234" height="22" rx="6" fill="rgba(76, 131, 255, 0.06)" />
      <text x="278" y="192" fill="#1c7ed6" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">Anton:</text>
      <text x="312" y="192" fill="var(--palette-foreground)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Release plan by 05-02")}</text>
      <rect x="270" y="204" width="234" height="22" rx="6" fill="rgba(76, 131, 255, 0.06)" />
      <text x="278" y="218" fill="#1c7ed6" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">Maria:</text>
      <text x="306" y="218" fill="var(--palette-foreground)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Stripe MVP by 05-08")}</text>

      {/* Speaking time */}
      <text x="20" y="250" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("SPEAKING TIME")}</text>

      {[
        { y: 264, name: "Anton", pct: 38, color: "#4c83ff" },
        { y: 280, name: "Maria", pct: 22, color: "#6c3fc4" },
        { y: 296, name: "Lena",  pct: 18, color: "var(--palette-positive)" },
        { y: 312, name: "Dmitry", pct: 12, color: "var(--palette-warning)" },
      ].map((p) => (
        <g key={p.name}>
          <text x="20" y={p.y + 8} fill="var(--palette-foreground)" fontSize="9" fontFamily="Open Sans, sans-serif">{p.name}</text>
          <rect x="80" y={p.y} width="380" height="10" rx="5" fill="rgba(0, 0, 0, 0.05)" />
          <rect x="80" y={p.y} width={p.pct * 3.8} height="10" rx="5" fill={p.color} />
          <text x="468" y={p.y + 8} fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif" textAnchor="end">{p.pct}%</text>
        </g>
      ))}
    </svg>
  );
}

function InfographicMeetingMemory() {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 520 340" fill="none" xmlns="http://www.w3.org/2000/svg" className="feat-infographic">
      <rect width="520" height="340" rx="16" fill="var(--palette-white)" />

      {/* Header bar */}
      <rect x="20" y="20" width="480" height="40" rx="8" fill="var(--palette-main-bg)" />
      <text x="32" y="44" fill="var(--palette-foreground)" fontSize="14">🧠</text>
      <text x="52" y="44" fill="var(--palette-foreground)" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Meeting Memory")}</text>

      {/* Tabs */}
      <rect x="280" y="30" width="50" height="20" rx="10" fill="rgba(108, 63, 196, 0.12)" />
      <text x="305" y="44" textAnchor="middle" fill="#6c3fc4" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Ask")}</text>
      <rect x="334" y="30" width="60" height="20" rx="10" fill="transparent" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="364" y="44" textAnchor="middle" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif">{t("Search")}</text>

      {/* Question input */}
      <rect x="20" y="76" width="380" height="36" rx="10" fill="var(--palette-input-bg)" stroke="var(--palette-neutral-lighten-2)" strokeWidth="1" />
      <text x="32" y="98" fill="var(--palette-foreground)" fontSize="11" fontFamily="Open Sans, sans-serif">{t("When did we discuss the Q3 budget?")}</text>
      <rect x="408" y="76" width="92" height="36" rx="10" fill="url(#mem-grad)" />
      <defs>
        <linearGradient id="mem-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4c83ff" />
          <stop offset="1" stopColor="#6c3fc4" />
        </linearGradient>
      </defs>
      <text x="454" y="98" textAnchor="middle" fill="#fff" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">{t("Ask")}</text>

      {/* Answer card */}
      <rect x="20" y="124" width="480" height="56" rx="10" fill="rgba(76, 131, 255, 0.06)" stroke="rgba(76, 131, 255, 0.2)" strokeWidth="1" />
      <text x="32" y="142" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("ANSWER")}</text>
      <text x="32" y="158" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("On April 22 you decided to cut Q3 marketing by 15%")}</text>
      <text x="32" y="172" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("and reallocate to Stripe integration")} <tspan fill="#1c7ed6">[1]</tspan> <tspan fill="#1c7ed6">[2]</tspan>.</text>

      {/* Sources label */}
      <text x="20" y="200" fill="var(--palette-neutral)" fontSize="9" fontWeight="700" fontFamily="Open Sans, sans-serif" letterSpacing="0.5">{t("SOURCES")}</text>

      {/* Source 1 — recording */}
      <rect x="20" y="208" width="480" height="58" rx="10" fill="var(--palette-main-bg)" stroke="rgba(0,0,0,0.05)" strokeWidth="1" />
      <text x="32" y="226" fill="#6c3fc4" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">[1]</text>
      <rect x="50" y="216" width="62" height="14" rx="7" fill="rgba(108, 63, 196, 0.12)" />
      <text x="81" y="226" textAnchor="middle" fill="#6c3fc4" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("RECORDING")}</text>
      <text x="118" y="226" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif" fontWeight="700">Anton</text>
      <text x="156" y="226" fill="var(--palette-neutral)" fontSize="10" fontFamily="Open Sans, sans-serif">@ 14:32</text>
      <text x="464" y="226" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif" textAnchor="end">96%</text>
      <text x="32" y="244" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("“Q3 budget — let’s tighten 15%, marketing first…”")}</text>
      <text x="32" y="260" fill="#1c7ed6" fontSize="9" fontFamily="Open Sans, sans-serif">▶ {t("Open at 14:32")}</text>

      {/* Source 2 — chat message */}
      <rect x="20" y="274" width="480" height="50" rx="10" fill="var(--palette-main-bg)" stroke="rgba(0,0,0,0.05)" strokeWidth="1" />
      <text x="32" y="292" fill="#6c3fc4" fontSize="11" fontWeight="700" fontFamily="Open Sans, sans-serif">[2]</text>
      <rect x="50" y="282" width="42" height="14" rx="7" fill="rgba(76, 131, 255, 0.14)" />
      <text x="71" y="292" textAnchor="middle" fill="#1c7ed6" fontSize="8" fontFamily="Open Sans, sans-serif" fontWeight="700">{t("CHAT")}</text>
      <text x="98" y="292" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif" fontWeight="700">Maria · #finance</text>
      <text x="464" y="292" fill="var(--palette-neutral)" fontSize="9" fontFamily="Open Sans, sans-serif" textAnchor="end">88%</text>
      <text x="32" y="312" fill="var(--palette-foreground)" fontSize="10" fontFamily="Open Sans, sans-serif">{t("“Q3 budget approved — Stripe MVP target Mon 8th”")}</text>
    </svg>
  );
}

/* ═══════════════════════════════════════════
   Section Meta (stable across languages — id, badge colour, infographic)
   Content (badge text, title, subtitle, details) lives in content.ts and is
   matched by index. Adding/removing an entry must be mirrored in content.ts.
   ═══════════════════════════════════════════ */

interface SectionMeta {
  id: string;
  badgeColor: string;
  infographic: React.ReactNode;
}

const SECTION_META: SectionMeta[] = [
  { id: "messaging", badgeColor: "var(--palette-primary)", infographic: <InfographicMessaging /> },
  { id: "video", badgeColor: "var(--palette-positive)", infographic: <InfographicVideo /> },
  { id: "advanced-calls", badgeColor: "#9c27b0", infographic: <InfographicAdvancedCalls /> },
  { id: "native-incoming-calls", badgeColor: "#0a84ff", infographic: <InfographicNativeCalls /> },
  { id: "smart-recording", badgeColor: "#e91e63", infographic: <InfographicSmartRecording /> },
  { id: "conference-transcription", badgeColor: "#00bcd4", infographic: <InfographicConferenceTranscription /> },
  { id: "ai-coach", badgeColor: "#6c3fc4", infographic: <InfographicMeetingCoach /> },
  { id: "ai-memory", badgeColor: "#4c83ff", infographic: <InfographicMeetingMemory /> },
  { id: "voice-clone", badgeColor: "#9c27b0", infographic: <InfographicVoiceClone /> },
  { id: "groups", badgeColor: "var(--palette-warning)", infographic: <InfographicGroups /> },
  { id: "files", badgeColor: "var(--palette-negative)", infographic: <InfographicFiles /> },
  { id: "security", badgeColor: "var(--palette-primary)", infographic: <InfographicSecurity /> },
  { id: "realtime", badgeColor: "var(--palette-positive)", infographic: <InfographicRealtime /> },
  { id: "channels", badgeColor: "var(--palette-primary)", infographic: <InfographicChannels /> },
  { id: "link-previews", badgeColor: "var(--palette-warning)", infographic: <InfographicLinkPreview /> },
  { id: "communication", badgeColor: "var(--palette-primary)", infographic: <InfographicCommunication /> },
  { id: "markdown", badgeColor: "var(--palette-positive)", infographic: <InfographicMarkdown /> },
  { id: "chat-folders", badgeColor: "#ff9800", infographic: <InfographicChatFolders /> },
  { id: "gif-stickers", badgeColor: "#e91e63", infographic: null },
  { id: "video-messages", badgeColor: "#9c27b0", infographic: null },
  { id: "ai-transcription", badgeColor: "#00bcd4", infographic: null },
  { id: "media-gallery", badgeColor: "#ff5722", infographic: null },
  { id: "dark-theme", badgeColor: "#607d8b", infographic: null },
  { id: "desktop-app", badgeColor: "#795548", infographic: null },
  { id: "saved-messages", badgeColor: "#3f51b5", infographic: null },
];

/* ═══════════════════════════════════════════
   Page Component
   ═══════════════════════════════════════════ */

export default function PageFeatures() {
  useTranslation();
  const lang = getCurrentLanguage();
  const C = getFeaturesContent(lang);

  useEffect(() => {
    document.title = C.meta.title;
    setMeta("description", C.meta.description);
    setOg("og:title", C.meta.title);
    setOg("og:description", C.meta.description);
    setOg("og:locale", lang === "ru" ? "ru_RU" : "en_US");
    setOg("og:url", "https://messenger.scrile.com/features");
    setCanonical("https://messenger.scrile.com/features");
    document.documentElement.setAttribute("lang", lang);
  }, [C, lang]);

  // Pair the static SECTION_META (id, badgeColor, infographic) with the
  // language-dependent content by index — both arrays must have the same length.
  const sections = SECTION_META.map((meta, i) => ({ meta, content: C.sections[i] }));

  return (
    <div className="page-features">
      {/* Hero */}
      <section className="feat-hero">
        <div className="feat-wrap">
          <div className="landing-badge">{C.hero.badge}</div>
          <h1 className="feat-hero__title">
            {C.hero.titleBefore}
            <span className="feat-hero__highlight">{C.hero.titleHighlight}</span>
          </h1>
          <p className="feat-hero__subtitle">{C.hero.subtitle}</p>
          <nav className="feat-nav">
            {sections.map(({ meta, content }) => (
              <a
                href={`#${meta.id}`}
                className="feat-nav__item"
                key={meta.id}
                style={{ "--nav-color": meta.badgeColor } as React.CSSProperties}
              >
                <span className="feat-nav__badge">{content.badge}</span>
                <span className="feat-nav__label">{content.title}</span>
              </a>
            ))}
          </nav>
        </div>
      </section>

      {/* Feature sections */}
      {sections.map(({ meta, content }, i) => (
        <section
          key={meta.id}
          id={meta.id}
          className={`feat-section ${i % 2 === 1 ? "feat-section--alt" : ""}`}
        >
          <div className="feat-wrap">
            <div className="feat-section__header">
              <span
                className="feat-section__badge"
                style={{ "--badge-color": meta.badgeColor } as React.CSSProperties}
              >
                {content.badge}
              </span>
              <h2 className="feat-section__title">{content.title}</h2>
              <p className="feat-section__subtitle">{content.subtitle}</p>
            </div>

            <div className="feat-section__infographic">{meta.infographic}</div>

            <div className="feat-details-grid">
              {content.details.map((d, di) => (
                <div className="feat-detail" key={di}>
                  <div className="feat-detail__dot" style={{ background: meta.badgeColor }} />
                  <div>
                    <h4 className="feat-detail__label">{d.label}</h4>
                    <p className="feat-detail__text">{d.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="feat-cta">
        <div className="feat-wrap">
          <h2 className="feat-cta__title">{C.cta.title}</h2>
          <p className="feat-cta__subtitle">{C.cta.subtitle}</p>
          <div className="feat-cta__actions">
            <Link to={Routes.signup} className="landing-btn landing-btn--white">
              {C.cta.getStarted}
            </Link>
            <Link to={Routes.landing} className="landing-btn landing-btn--ghost">
              {C.cta.backToOverview}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
